import React, { memo } from "react";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

const AdditionalControls: React.FC<{
  isLoading: boolean;
  selectedTemplate: any;
  onRevertClick: () => void;
  onApplyClick: () => void;
  onSelectTemplate?: (e: any) => void;
  recoveryTemplates?: any;
}> = memo((props) => {
  return (
    <div className="flex space-x-2">
      <FormControl sx={{ m: 0, minWidth: 200 }} size="small">
        <InputLabel id="demo-select-small-label">Use a Template</InputLabel>
        <Select
          labelId="demo-select-small-label"
          id="demo-select-small"
          value={props.selectedTemplate}
          label="Age"
          onChange={props.onSelectTemplate}
        >
          {props.recoveryTemplates.map((el: any, index: number) => (
            <MenuItem
              value={el.value}
              key={el.value}
              disableRipple
              divider={el.hasDivider}
            >
              {el.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button
        className="revert-button"
        disabled={props.isLoading}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation();
          props.onRevertClick();
        }}
      >
        Revert
      </Button>
      <Button
        disabled={props.isLoading}
        className="apply-button"
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation();
          props.onApplyClick();
        }}
      >
        {props.isLoading ? (
          <Box width="98px">
            <CircularProgress color="inherit" size={15} />
          </Box>
        ) : (
          "Apply Changes"
        )}
      </Button>
    </div>
  );
});

export default AdditionalControls;
